var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c('span',{staticClass:"mr-2"},[_vm._v("Hamochi")]),_c('v-chip',{staticClass:"mr-1",attrs:{"small":""}},[_vm._v("Beta "+_vm._s(_vm.$version))]),(_vm.env != 'production' && _vm.env != 'release')?_c('v-chip',{staticClass:"d-none d-sm-flex",attrs:{"small":""}},[_vm._v(_vm._s(_vm.env))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }